import React, { Component } from "react";

import { createStore, combineReducers } from "redux";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/lib/integration/react";

import { Provider } from "react-redux";

import authReducer from "../../reducers/auth_reducer";
import selectReducer from "../../reducers/select_reducer";
import uiReducer from "../../reducers/ui_reducer";

import Routes from "./Routes";
import { signOutAction } from "../../actions/auth_actions";

import { Fabric } from "office-ui-fabric-react/lib/Fabric";
import { initializeIcons } from "@uifabric/icons";

import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "apollo-link-error";
import { ApolloProvider } from "react-apollo";
import { loadTheme } from "office-ui-fabric-react/lib/Styling";
import { ToastContainer } from "react-toastify";

const persistConfig = {
  key: "root",
  storage
};

loadTheme({
  palette: {}
});

initializeIcons();

const httpLink = createHttpLink({
  // uri: process.env.REACT_APP_GRAPHQL_API
  // uri: 'http://192.168.1.20:5000/graphql'
   uri: 'https://apiv1.colourrush.nl/graphql'
});

const authLink = setContext(() => {
  const token = localStorage.getItem("token");
  if (token) {
    return {
      headers: {
        authorization: token ? `Bearer ${token}` : null
      }
    };
  }
});

const beforeLink = authLink.concat(httpLink);

const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (
    networkError &&
    networkError.statusCode >= 400 &&
    networkError.statusCode <= 500
  ) {
    console.log('err') 
    store.dispatch(signOutAction());
  }
});

const link = errorLink.concat(beforeLink);

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
  // connectToDevTools: true,
  queryDeduplication: true
});

const store = createStore(
  combineReducers({
    ui: uiReducer,
    selected: selectReducer,
    auth: persistReducer(persistConfig, authReducer)
  }),
  {}
  //  ,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

let persistor = persistStore(store);

class App extends Component {
  render() {
    return (
      <div>
        <PersistGate persistor={persistor}>
          <Fabric>
            <Provider store={store}>
              <ApolloProvider client={apolloClient}>
                <Routes />
              </ApolloProvider>
            </Provider>
          </Fabric>
        </PersistGate>
        <ToastContainer autoClose={2000} position={"bottom-left"} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/views/App/App.js